import React from 'react'
import { render } from 'react-dom'

import components from './components'

export default function renderComponent(target, name, props) {
  const Component = components[name]

  render(<Component {...props} />, target)
}
